<div fusePerfectScrollbar fxLayout="column">
    <mat-table class="mat-card hours-table"
               #table [dataSource]="dataSource"
               fusePerfectScrollbar>

        <!-- ID Column -->
        <ng-container matColumnDef="roleName">
            <mat-header-cell style="color: white" fxFlex="50" *matHeaderCellDef>Rol</mat-header-cell>
            <mat-cell  fxFlex="50" *matCellDef="let aux">
                <p class="number text-truncate">{{roleName(aux.roleId)}}</p>
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="estimatedHH">
            <mat-header-cell style="color: white" fxFlex="25" *matHeaderCellDef>HH Estimadas</mat-header-cell>
            <mat-cell fxFlex="25" *matCellDef="let aux">
                <p class="text-truncate">{{aux.estimatedHH}}</p>
            </mat-cell>
        </ng-container>

        <!-- Cantidad de horas -->
        <ng-container matColumnDef="estimatedCosts">
            <mat-header-cell style="color: white" fxFlex="25" *matHeaderCellDef fxHide fxShow.gt-md>Costo Estimado</mat-header-cell>
            <mat-cell fxFlex="25" *matCellDef="let aux" fxHide fxShow.gt-md>
                <p class="creationDate text-truncate">
                    {{aux.estimatedHH * aux.hourIncome}}
                </p>
            </mat-cell>
        </ng-container>

        <mat-header-row  *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

        <mat-row *matRowDef="let aux; columns: displayedColumns;" class="hours"
                 [ngClass]="{'highlight': selectedRoleId == aux.roleId}"
                 (click)="highlight(aux)">
        </mat-row>
    </mat-table >
    <div fxLayout="row" class="pt-8" *ngIf="canModify">
        <mat-form-field dense appearance="outline" floatLabel="always" fxFlex="70">
            <mat-label>Rol</mat-label>
            <mat-select #roles  [value]="">
                <mat-option *ngFor="let rol of _systemService.roles" [value]="rol">
                    {{rol.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field dense appearance="outline" fxFlex="30">
            <mat-label>Cantidad</mat-label>
            <input [(ngModel)]="cantidad" matInput type="number">
        </mat-form-field>
        <button mat-raised-button (click)="agregarEstimacion(roles.value)"><mat-icon>add_box</mat-icon> </button>
        <button mat-raised-button [disabled]="!selectedRoleId" (click)="quitarEstimacion(selectedRoleId)"><mat-icon>delete</mat-icon> </button>
    </div>

</div>
